import React from 'react';
import { Row } from 'antd';
import MegaMenuItem from '../MegaMenuItem';
import { SubMegaMenuContainer } from './styles';

const SubMegaMenu = ({
  groupLabel,
  navItems = [],
  isMenuOpened,
  setMobileMenuOpened,
  isProProducts,
  ...otherProps
}) => {
  const type = groupLabel === 'Footer' || groupLabel === 'Pro Products' ? 'footer' : 'normal';
  return (
    <SubMegaMenuContainer
      className={'sub-mega-menu' + (type === 'footer' ? ' sub-mega-menu-footer' : '')}
      isProProducts={isProProducts}
      {...otherProps}
    >
      {<div className="sub-mega-menu--title">{groupLabel}</div>}
      <ul className="sub-mega-menu--content">
        <Row>
          {navItems.map((item, index) => (
            <MegaMenuItem
              type={item.label.includes('See All') ? 'footer' : 'icon-title-desc'}
              icon={
                item.icon && item.icon.image && item.icon.image.file && item.icon.image.file.url
              }
              alt={item.icon && item.icon.alt}
              title={item.label}
              link={item.url}
              key={index}
              setMobileMenuOpened={setMobileMenuOpened}
            >
              {item.description}
            </MegaMenuItem>
          ))}
        </Row>
      </ul>
    </SubMegaMenuContainer>
  );
};

export default SubMegaMenu;
